import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

const pathwaysHolderData = [
    {
        _id: 'pathway1',
        name: 'Pathway 1',
        subtitle: 'The first pathway',
        isActive: false,
        subscriptionType: 'AvailableForAll',
        objectives: ['get better'],
        pace: '2 hours a month',
        bestFor: ['yes'],
        thumbnailImageUrl: 'https://res.cloudinary.com/goverb/image/upload/v1588194059/gi5vkl7frned4zbfie1i.jpg',
        content: [
            '5a6217825b1f570010819bb0',
            '5a0dd30d2b8c5f000faba842',
            '5a0b2453b88b630010557c7c',
            '59ee4625f8a65300100ae5bf'
        ]
    },
    {
        _id: 'pathway2',
        name: 'Pathway 2',
        subtitle: 'The second pathway',
        isActive: false,
        subscriptionType: 'AvailableForAll',
        objectives: ['get better a second time'],
        pace: '2 hours a month',
        bestFor: ['yes'],
        thumbnailImageUrl: 'https://res.cloudinary.com/goverb/image/upload/v1588194059/gi5vkl7frned4zbfie1i.jpg',
        content: ['5a6fa770d100920011dc3ee6', '5a6fa905ef8635000f6c7908', '59cd5e2cecbaf10011d95769']
    }
];

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
// eslint-disable-next-line arrow-body-style
export const getManyAdminPathways = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/pathways`;
    let url;

    if (rest && rest.dispatchDisabled) {
        delete rest.dispatchDisabled;
        url = buildQueryString(rest, baseUrl);
        return VerbFetch(url);
    }

    url = buildQueryString(rest, baseUrl);
    return (dispatch) => {
        dispatch({
            type: ACTIONS.GET_MANY_PATHWAYS_START
        });
        return VerbFetch(url).then((result) => {
            dispatch({
                type: ACTIONS.GET_MANY_PATHWAYS,
                payload: {
                    pathways: result
                }
            });
            return result;
        });
    };
};

// eslint-disable-next-line arrow-body-style
export const getAdminPathway = (params) => {
    const { pathwayId, pathsContext } = params;
    const url = `${pathsContext.adminServerUrl}/pathways/${pathwayId}`;

    if (params && params.dispatchDisabled) {
        return VerbFetch(url);
    }

    return (dispatch) =>
        VerbFetch(url).then((result) => {
            const [pathway] = result;
            dispatch({
                type: ACTIONS.GET_PATHWAY,
                payload: {
                    pathway
                }
            });
            return pathway;
        });
};

export const postAdminPathway = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) =>
        VerbFetch(`${pathsContext.adminServerUrl}/pathways`, {
            method: 'POST',
            body
        }).then((body) => {
            dispatch({
                type: ACTIONS.POST_PATHWAY_SUCCESS,
                payload: {
                    pathway: body
                }
            });
            return body;
        });
};

export const putAdminPathway = (params) => {
    const { pathwayId, body, options, pathsContext } = params;
    const assignedTo = body ? body.assignedTo : null;
    const baseUrl = `${pathsContext.adminServerUrl}/pathways/${pathwayId}`;
    const url = buildQueryString(options, baseUrl);
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_PATHWAY_START,
            payload: {
                body
            }
        });
        return VerbFetch(url, {
            method: 'PUT',
            body
        }).then((body) => {
            if (assignedTo) {
                body.assignedTo = assignedTo;
            }
            dispatch({
                type: ACTIONS.PUT_PATHWAY_SUCCESS,
                payload: {
                    pathway: body
                }
            });
            return body;
        });
    };
};

export const putAdminPathwayAssociatedCompanyLicenses = (params) => {
    const { body, pathwayId, pathsContext } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/pathways/${pathwayId}/licenses`;
    return VerbFetch(baseUrl, {
        method: 'PUT',
        body
    }).then((result) => result);
};

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
// eslint-disable-next-line arrow-body-style
export const getManyPathways = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/pathways`;
    let url;

    if (rest && rest.dispatchDisabled) {
        delete rest.dispatchDisabled;
        url = buildQueryString(rest, baseUrl);
        return VerbFetch(url);
    }

    url = buildQueryString(rest, baseUrl);
    return (dispatch) => {
        dispatch({
            type: ACTIONS.GET_MANY_PATHWAYS_START
        });
        return VerbFetch(url).then((result) => {
            dispatch({
                type: ACTIONS.GET_MANY_PATHWAYS,
                payload: {
                    pathways: result
                }
            });
            return result;
        });
    };
};

// eslint-disable-next-line arrow-body-style
export const getPathway = (params) => {
    const { pathwayId, pathsContext } = params;
    const url = `${pathsContext.serverUrl}/pathways/${pathwayId}`;

    if (params && params.dispatchDisabled) {
        return VerbFetch(url);
    }

    return (dispatch) =>
        VerbFetch(url).then((result) => {
            dispatch({
                type: ACTIONS.GET_PATHWAY,
                payload: {
                    pathway: result[0]
                }
            });
            return result;
        });
};

export const getAdminPathwayStatus = (params) => {
    const { pathsContext, pathwayId } = params;
    return VerbFetch(`${pathsContext.adminServerUrl}/pathways/${pathwayId}/status`, {
        method: 'GET'
    })
        .then((result) => result)
        .catch((err) => {
            console.error(err);
            return { error: true };
        });
};

export const getAdminArchivedPathways = (params) => {
    const { pathsContext, ...options } = params;
    options.isArchived = true;
    const baseUrl = `${pathsContext.adminServerUrl}/pathways`;
    const url = buildQueryString(options, baseUrl);

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_MANY_ARCHIVED_PATHWAYS,
                payload: {
                    pathways: body
                }
            });
            return body;
        });
};

export const getAdminFilteredPathways = () => (dispatch) =>
    Promise.resolve(pathwaysHolderData).then((result) => {
        dispatch({
            type: ACTIONS.GET_FILTERED_PATHWAYS,
            payload: {
                pathways: result
            }
        });
        return result;
    });

export const clearSearchedPathways = () => (dispatch) =>
    dispatch({
        type: ACTIONS.CLEAR_SEARCHED_PATHWAYS
    });

export const getCompanyExclusivePathways = (params) => {
    const { pathsContext, ...options } = params;
    options.subscriptionType = 'ExclusiveCompanyLicense';

    const baseUrl = `${pathsContext.adminServerUrl}/pathways`;
    const url = buildQueryString(options, baseUrl);

    return (dispatch) =>
        VerbFetch(url).then((result) => {
            dispatch({
                type: ACTIONS.GET_COMPANY_EXCLUSIVEPATHWAYS_SUCCESS,
                payload: {
                    pathways: result
                }
            });
            return result;
        });
};

export const archivePathway = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_PATHWAY_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/pathways/${body._id}/archive`, {
            method: 'PUT',
            body: { isArchived: true }
        }).then((result) => {
            dispatch({
                type: ACTIONS.PUT_ARCHIVED_PATHWAY_SUCCESS,
                payload: {
                    pathway: result
                }
            });
            return result;
        });
    };
};

export const deletePathway = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.DELETE_PATHWAY_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/pathways/${body._id}`, {
            method: 'DELETE'
        }).then((result) => {
            dispatch({
                type: ACTIONS.DELETE_PATHWAY_SUCCESS,
                payload: {
                    pathway: body
                }
            });
            return result;
        });
    };
};

export const unarchivePathway = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_PATHWAY_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/pathways/${body._id}/archive`, {
            method: 'PUT',
            body: { isArchived: false }
        }).then((result) => {
            dispatch({
                type: ACTIONS.PUT_UNARCHIVED_PATHWAY_SUCCESS,
                payload: {
                    pathway: result
                }
            });
            return result;
        });
    };
};

export const pushPathwayToCompanyMembers = (params) => {
    const { body, pathsContext } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/userpathways/push`;
    return VerbFetch(baseUrl, {
        method: 'POST',
        body
    })
        .then((result) => result)
        .catch((err) => {
            console.error(err);
            return { status: 'Something went wrong', error: true };
        });
};
